import {useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import {AuthContext} from '@/context/Auth/AuthContext';
import {AvatarButton} from '@/components/atoms';
import {ROUTES} from '@/utils/constants/routesConstants';

/**
 * A button component that displays a user avatar with the user's name and handles navigation on click
 * @param {Object} props - The component props
 * @returns {JSX.Element} UserAvatarButton component
 */
export function UserAvatarButton() {
  const {claims} = useContext(AuthContext);
  const navigate = useNavigate();

  const firstName = claims.firstName || claims.given_name;
  const lastName = claims.lastName || claims.family_name;
  const fullName =
    [firstName, lastName].filter(Boolean).join(' ') ||
    claims.name ||
    claims.email ||
    claims.preferred_username ||
    '';

  return (
    <AvatarButton
      name={fullName}
      onClick={() => navigate(ROUTES.LOGOUT)}
      testId='header-user-avatar'
      type='text'
      showArrowIcon={true}
    />
  );
}
